/**
 * Container classes for the SidebarMenu root.
 * The consumer is responsible for placement (drawer, fixed page column) and
 * width transitions — the organism just renders the vertical content.
 */
export const sidebarMenuRootClasses = "bg-luce-neutral-background-default flex h-full flex-col";

/** Section wrapper: vertical column of header + items. */
export const sidebarMenuSectionClasses = "gap-spacing-sm p-spacing-lg flex flex-col";

/** Inner list wrapper that holds the `SidebarNavItem` `<li>` rows. */
export const sidebarMenuSectionListClasses = "list-none flex flex-col gap-1";

/** Bottom divider between sections. */
export const sidebarMenuSectionDividerClasses =
  "border-luce-neutral-border-mediumEmphasis border-t";
